"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionNumberGuard = questionNumberGuard;
const navigation_1 = require("next/navigation");
const validators_1 = require("../validators/index.js");
function questionNumberGuard(questionNumber) {
    try {
        return (0, validators_1.validateQuestionNumber)(questionNumber);
    }
    catch {
        (0, navigation_1.notFound)();
    }
}
